<template>
  <div class="header">
    <el-menu class="nav" mode="horizontal" text-color="#404040"
             default-active="activeIndex" @select="handleSelect"
             active-text-color="#409EFF">
      <el-menu-item index="0" class="nav_logo" @click="toHome()">
        <div>青少年编程考试模拟教学平台</div>
      </el-menu-item>
      <el-menu-item index="1" class="nav_search_item">
        <div class="nav_search" v-if="this.$route.name ==='homePage'">
          <el-input class="nav_search_input"
                    v-model="searchPaperName"
                    maxlength="40"
                    placeholder="请输入试卷标题"
                    @keyup.enter.native="selectPaperName">
            <el-button slot="append" type="primary" @click="selectPaperName">搜索</el-button>
          </el-input>
        </div>
        <div v-else style="width: 200px"></div>
      </el-menu-item>
      <el-menu-item index="2" @click="toHome()"
                    class="right-align">首页
      </el-menu-item>

      <el-menu-item index="3" @click="toPaperList()" class="right-align">试卷中心
      </el-menu-item>
      <el-menu-item index="4" @click="toQuestionBank()" class="right-align">题库搜题</el-menu-item>
      <el-menu-item index="5" @click="toExaminationRecord()" class="right-align">考试记录</el-menu-item>
      <el-menu-item index="6" @click="toWrongBook()" class="right-align" v-if="this.$route.name !=='homePage'">
        错题本
      </el-menu-item>

      <el-menu-item index="8" v-if="!titleShow && this.$route.name !=='homePage'" @click="toTeacherManage()">
        教学中心
      </el-menu-item>

      <el-menu-item index="20" v-if="titleShow" @click="toMyWork()">我的作业</el-menu-item>

      <el-menu-item index="7" v-if="!titleShow" @click="toSelfVIP()" class="nav_vip right-align">
        <img class="vip_img" src="@/assets/vip5.svg">会员中心
      </el-menu-item>
      <el-menu-item index="9" @click="toNotice()" v-if="this.$route.name !=='homePage'"
                    style="padding-right:10px">公告
      </el-menu-item>

      <el-menu-item index="10" class="nav_user">
        <div v-if="haveToken">
          <el-popover placement="bottom" trigger="click"
                      popper-class="custom-popper"
                      ref="popover"
          >
            <template #reference>
              <el-image style="width: 36px; height: 36px;"
                        :src="iconUrl"
                        fit="fill"></el-image>
            </template>
            <div style="text-align: center;">
              <router-link :to="{ name: 'selfInfo', params: { activeName: 'personalInfo' } }"
                           class="nav_user_detail">个人中心
              </router-link>
              <router-link to="/examinationRecord" class="nav_user_detail">考试记录</router-link>
              <router-link to="/wrongBook" class="nav_user_detail">错题本</router-link>
              <router-link :to="{ name: 'selfInfo', params: { activeName: 'classDetails' } }"
                           class="nav_user_detail" @click="closePopover">我的课程
              </router-link>
              <p style="cursor:pointer" @click="logoutSys()">
                <router-link to="/" class="nav_user_detail">退出登录</router-link>
              </p>
            </div>
          </el-popover>
        </div>
        <div v-if="!haveToken">
          <el-button type="warning" size="mini"
                     @click="login()">登录/注册
          </el-button>
        </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {logoutSystem, homeTitle, homePaper} from "@/api/index.js"

export default {
  data() {
    return {
      activeIndex: '2',
      searchPaperName: '',
      visible: false,
      ggFlag: true,
      inputHighlighted: false,
      input: "",
      iconUrl: require('@/assets/boy.png'),
      haveToken: false,
      titleShow: false,
      title: "青少年编程考试模拟教学平台"
    }
  },
  watch: {
    loginDialogShow: {
      handler: function (n, o) {
        this.getToken()
      }
    }
  },
  props: ["loginDialogShow"],
  created() {
    this.getToken()
  },
  mounted() {
    this.getToken()
    // this.getTitle()
  },
  methods: {
    closegg() {
      this.ggFlag = false
    },
    login() {
      this.$emit("clickLogin")
    },
    getToken() {
      if (localStorage.getItem("token")) {
        this.haveToken = true;
        if ("2" === localStorage.getItem("sex")) {
          this.iconUrl = require('@/assets/girl.png')
        } else {
          this.iconUrl = require('@/assets/boy.png')
        }
        if (localStorage.getItem("agentFlag") === '1') {
          if (localStorage.getItem("teacherFlag") === '0') {
            this.titleShow = true;
          }
        }

      } else {
        this.haveToken = false
      }
    },
    getTitle() {
      this.loading = true;
      homeTitle().then(res => {
        if (res.code === "0000") {
          this.loading = false;
        }
      })
    },
    searchPaperOrQuestion() {
      this.inputHighlighted = true
      console.log(this.inputHighlighted)
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key
    },
    toHome() {
      this.$router.push({name: 'homePage'})
      window.scrollTo(0, 0)
    },
    selectPaperName() {
      this.$router.push({
        name: 'testPaperCenter',
        query: {
          searchPaperName: this.searchPaperName
        }
      });
      window.scrollTo(0, 0);
      this.searchPaperName = '';

    },
    toPaperList() {
      this.$router.push({name: 'testPaperCenter'})
      window.scrollTo(0, 0)
    },
    toExaminationRecord() {
      this.$router.push({name: 'examinationRecord'})
      window.scrollTo(0, 0)
    },
    toWrongBook() {
      this.$router.push({name: 'wrongBook'})
      window.scrollTo(0, 0)
    },
    toQuestionBank() {
      this.$router.push({name: 'questionBank'})
      window.scrollTo(0, 0)
    },
    toMyWork() {
      this.$router.push({name: 'myWork'})
      window.scrollTo(0, 0)
    },
    toTeacherManage() {
      this.$router.push({name: 'teacherManage'})
      window.scrollTo(0, 0)
    },
    toSelfVIP() {
      this.$router.push({name: 'selfVIP'})
      window.scrollTo(0, 0)
    },
    toScratchLab() {
      let token = localStorage.getItem("token");
      let sessionId = localStorage.getItem("sessionId")
      let username = localStorage.getItem("username")
      // window.location.href = `http://localhost:5173/#token=${encodedToken}`;
      if (token) {
        window.open(`http://scratch.wancode.net/#/token=${token}&sessionId=${sessionId}`, '_blank');
      } else {
        window.open(`http://scratch.wancode.net`, '_blank');
      }
    },

    toCourseSelectionCenter() {
      this.$router.push({name: 'courseSelectionCenter'})
      window.scrollTo(0, 0)
    },
    toShoppingMall() {
      this.$router.push({name: 'shoppingMall'})
      window.scrollTo(0, 0)
    },
    toNotice() {
      this.$router.push({name: 'notice'})
      window.scrollTo(0, 0)
    },
    logoutSys() {
      this.drawerVisible = false;
      this.haveToken = false;
      logoutSystem().then(res => {
        if (res.code === "0000") {
          this.$message.success("成功退出")
          this.iconUrl = ''
          localStorage.setItem("token", "");
          localStorage.removeItem("userId")
          localStorage.removeItem("userVipType")
          localStorage.removeItem("userId")
          localStorage.removeItem("username")
          localStorage.removeItem("agentFlag")
          localStorage.removeItem("teacherFlag")
          this.$router.push({ name: 'homePage' })
          window.scrollTo(0, 0)
        }
      })
    },
    closePopover() {
      this.$refs.popover.doClose();
    }

  }
}
</script>

<style>
/* ============ 全局字体优化 ============ */
.custom-popper {
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  border: none;
}

.custom-popper .nav_user_detail {
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;
}

/* ============ 导航菜单优化 ============ */
.el-menu--horizontal > .el-menu-item:hover {
  color: #409EFF !important;
  background: linear-gradient(180deg, transparent 0%, rgba(64, 158, 255, 0.06) 100%);
}

/* Logo始终保持透明背景，避免与渐变文字冲突 */
.el-menu--horizontal > .el-menu-item.nav_logo,
.el-menu--horizontal > .el-menu-item.nav_logo:hover,
.el-menu--horizontal > .el-menu-item.nav_logo:focus,
.el-menu--horizontal > .el-menu-item.nav_logo:active {
  background: transparent !important;
  background-color: transparent !important;
}

.el-menu--horizontal.nav > .el-menu-item {
  border-bottom: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.el-menu--horizontal.nav > .el-menu-item.is-active {
  border-bottom: none;
  color: #409EFF;
  background: linear-gradient(180deg, transparent 0%, rgba(64, 158, 255, 0.08) 100%);
}

/* ============ 搜索框优化 ============ */
.el-input.input-highlighted .el-input__inner {
  border-color: #667eea !important;
  background: #ffffff;
}

.el-input.nav_search_input .el-input__inner {
  height: 38px;
  border: 2px solid #e1e8ed !important;
  border-radius: 20px 0 0 20px;
  border-right: none !important;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 14px;
  background: #ffffff;
  padding-left: 40px;
  line-height: 38px;
}

.el-input.nav_search_input .el-input__inner:focus {
  border-color: #667eea !important;
  background: #ffffff;
}

.el-input.nav_search_input .el-input__inner::placeholder {
  color: #a8b2c1;
  font-weight: 400;
  opacity: 0.7;
}

.el-input.nav_search_input .el-input__inner,
.button {
  margin: 0;
  padding: 0;
}

.el-row {
  display: flex;
  align-items: center;
}

.el-row > .el-input {
  flex: 1;
}

</style>
<style lang="scss" scoped>

/* ============ 全局字体变量 ============ */
$font-family-base: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
$font-family-logo: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;

::v-deep .el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 10px;
}

.header {
  height: 60px;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
  color: #333;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 100;
  font-family: $font-family-base;
}

.guang-gao {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 999;

  .close {
    position: absolute;
    top: 10px;
    right: 20px;
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    font-style: normal;
  }

  a {
    background: transparent;
    color: #333;
    cursor: pointer;
    text-decoration: none;

    display: inline-block;
    max-width: 100%;
    max-height: 150px;

    img {
      border: 0;
      vertical-align: middle;

      display: block;
      max-height: 150px;
      max-width: 100%;

    }
  }
}

.nav {
  text-decoration: none;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;

  .nav_logo {
    width: 240px;

    div {
      font-family: $font-family-logo;
      font-size: 18px;
      font-weight: 700;
      background: linear-gradient(135deg, #409EFF 0%, #1890ff 50%, #0052d9 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      letter-spacing: 1px;
      text-shadow: 0 2px 4px rgba(64, 158, 255, 0.1);
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.02);
        filter: brightness(1.1);
      }
    }
  }

  .nav_search {
    margin-left: 40px;
    margin-right: 20px;

    .nav_search_input {
      width: 320px;
      
      ::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 18px 0 0 18px;
        border: 1px solid #dcdfe6;
        border-right: none;
        font-size: 14px;
        padding-left: 16px;
        background: transparent;
        
        &:focus {
          border-color: #606266;
        }
      }
      
      ::v-deep .el-input-group__append {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 0 18px 18px 0;
        padding: 0 18px;
        
        .el-button {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          padding: 0;
          margin: 0;
          border: none;
          background: transparent;
          
          &:hover {
            background: transparent;
            opacity: 0.9;
          }
        }
      }
    }
  }
}

/* ============ 导航菜单项样式 ============ */
.el-menu-item {
  padding: 0 12px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.3px;

  &:hover {
    color: #409EFF !important;
  }
}

/* 搜索框和用户区域禁用悬浮效果 */
.el-menu--horizontal > .el-menu-item.nav_search_item,
.el-menu--horizontal > .el-menu-item.nav_user {
  &:hover {
    background: transparent !important;
    color: inherit !important;
  }
}

.el-menu--horizontal > .el-menu-item.nav_logo {
  padding-left: 0;
}

.el-menu--horizontal > .el-menu-item.nav_vip {
  margin-right: 0;
  color: #ff6b35;
  font-weight: 600;

  &:hover {
    color: #ff8c5a !important;
  }
}

.vip_img {
  width: 22px;
  height: 22px;
  padding-right: 4px;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1) rotate(-5deg);
  }
}


/* ============ 用户头像区域 ============ */
.nav_user {
  
  .el-image {
    border-radius: 50%;
    border: 2px solid #e8f4ff;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);

    &:hover {
      border-color: #409EFF;
      transform: scale(1.08);
      box-shadow: 0 4px 16px rgba(64, 158, 255, 0.3);
    }
  }
}

.nav_user_detail {
  display: block;
  line-height: 44px;
  height: 44px;
  text-decoration: none;
  color: #606266;
  padding: 0 20px;
  margin: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.3px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    color: #409EFF;
    background: linear-gradient(135deg, #e8f4ff 0%, #f0f7ff 100%);
    transform: translateX(4px);
  }

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }
}

/* ============ 登录按钮优化 ============ */
::v-deep .el-button--warning {
  background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%);
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(255, 107, 0, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: linear-gradient(135deg, #ffaa33 0%, #ff8533 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(255, 107, 0, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

</style>
